import '@fontsource/montserrat/300.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
import './styles/main.scss';
import { initForms } from './js/form.js';
import { initMenu } from './js/menu.js';
import { initReveal } from './js/reveal.js';

initMenu();
initForms();
initReveal();
